<div class="pt-4 pb-4">
  <div class='container system-error' [attr.data-qa]="'system-error-container'">
    <div class="row fullpage-error">
      <div class="col-md-4 col-xs-12 sorry-img" [attr.data-qa]="'sorry-img'">
        <img src="/ucd/images/sorry.jpg" class="img-responsive" alt="">
      </div>
      <div class="col-md-8 col-xs-12" [attr.data-qa]="'sorry-text'">
        <p>
          Uh oh, we're having some trouble retrieving your account information for technical reasons.
        </p>
        <p>
          Please try logging out and back in again and if still not working give us a little time to sort it out.  
        </p>
        <p>
          If you need assistance right away, please call 1-800-PRU-HELP.  We apologize for the inconvenience and greatly appreciate your business.  
        </p>
      </div>
    </div>
  </div>
</div>